
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.1645',
  depVersions: {
  "customer-portal-app": "static-1.1645",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.444",
  "data-fetching-client": "static-1.9462",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.387",
  "growth-payments-core": "static-1.24685",
  "head-dlb": "static-1.4754",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5375",
  "hs-test-utils": "static-1.7788",
  "hub-http": "static-1.5966",
  "hub-http-shared-msw-handlers": "static-1.9439",
  "hubspot-dlb": "static-2.1796",
  "hubspot-prosemirror": "static-1.17564",
  "hubspot-url-utils": "static-1.3917",
  "HubStyleTokens": "static-2.11206",
  "I18n": "static-7.1564",
  "immutable": "static-2.19",
  "jasmine-runner": "static-1.6255",
  "payment-link-components": "static-1.22898",
  "prosemirror": "static-1.13",
  "quartz": "static-1.6703",
  "quartz-core": "static-1.5922",
  "react": "static-7.177",
  "react-colorpicker": "static-2.9993",
  "react-dlb": "static-1.71",
  "react-utils": "static-2.5157",
  "rich-text-lib": "static-1.19442",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.17626",
  "ui-components-test-utils": "static-1.5344",
  "UIComponents": "static-3.8153",
  "foundations-assets": "static-1.4618",
  "foundations-components": "static-1.7491",
  "foundations-theming": "static-1.4193",
  "foundations-theming-specialty": "static-1.1909",
  "framer-motion": "static-1.67",
  "history": "static-4.47",
  "metrics-js": "static-1.9391",
  "PortalIdParser": "static-2.349",
  "portals-platform-lib": "static-1.516",
  "quartz-config": "static-1.481",
  "quartz-routing": "static-1.133",
  "quick-fetch": "static-1.3718",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16426",
  "react-router-dom": "static-5.26",
  "sanitize-text": "static-1.7922",
  "styled-components": "static-2.84",
  "tanstack-table": "static-1.50",
  "ui-addon-draggable": "static-3.4549",
  "ui-addon-react-router-dom": "static-1.9331",
  "usage-tracker": "static-1.7115",
  "usage-tracker-anonymous": "static-1.5532",
  "usage-tracker-core": "static-1.6965",
  "apollo-stack-hubspot": "static-3.79",
  "hs-promise-rejection-tracking": "static-1.5291",
  "raven": "static-3.5624",
  "raven-hubspot": "static-1.5931",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.66",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3211",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2980",
  "quartz-webpack": "static-1.2927",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.77",
  "customer-data-objects": "static-1.7429",
  "frontend-preferences-client": "static-1.7707",
  "laboratory-lib": "static-3.6945",
  "onboarding-scopes": "static-1.6246",
  "rpc-client-utils": "static-1.4415",
  "ui-addon-opt": "static-4.8168",
  "HeadJS": "static-2.706",
  "hs-test-utils-bend-plugin": "static-1.2899",
  "msw": "static-1.39",
  "testing-library": "static-1.147",
  "ts-schema": "static-1.3887",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7424",
  "cssUtils": "static-1.726",
  "customer-data-ui-utilities": "static-1.9608",
  "HubStyle": "static-2.11514",
  "knowledge-content-types": "static-1.8352",
  "PatternValidationJS": "static-1.437",
  "quartz-i18n": "static-1.378",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.483",
  "ui-addon-emoji-picker": "static-1.9672",
  "ui-addon-i18n": "static-1.10918",
  "ui-business-units-lib": "static-1.8809",
  "ui-shepherd-react": "static-3.9928",
  "video-components-external": "static-1.10513",
  "i18n-data": "static-1.216",
  "moment-timezone": "static-5.78",
  "jasmine": "static-4.4111",
  "commerce-tours-lib": "static-1.5691",
  "customer-data-properties": "static-1.50755",
  "getting-started-shared-tasks": "static-1.17838",
  "growth-onboarding-reliability": "static-1.4870",
  "onboarding-tours": "static-1.16231",
  "reference-resolvers-lite": "static-1.7874",
  "sales-checkout-service-client": "static-1.3461",
  "ui-addon-iframeable": "static-1.8825",
  "user-context": "static-1.4878",
  "dispatcher": "static-1.132",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.789",
  "hubspotter-http": "static-1.4461",
  "icons": "static-2.620",
  "mobile-manifest-mixins": "static-1.479",
  "module-federation": "static-1.18",
  "quartz-auth": "static-1.378",
  "quartz-head": "static-1.368",
  "quartz-test": "static-1.378",
  "ui-fonts": "static-1.468",
  "usage-tracker-container": "static-1.7105",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9211",
  "data-token-picker": "static-1.16014",
  "FileManagerLib": "static-1.38477",
  "property-translator": "static-1.5196",
  "atom": "static-1.4853",
  "merchandise-lib": "static-1.258",
  "purchase-motions-components": "static-1.5459",
  "salesImages": "static-1.520",
  "self-service-api": "static-1.10019",
  "SharedI18nStrings": "static-1.180",
  "foundations-components-test-utils": "static-1.4974",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.94",
  "ui-images": "static-2.1087",
  "bend-plugin-foundations-components": "static-1.3760",
  "floating-ui": "static-1.51",
  "react-aria": "static-1.61",
  "trellis-assets": "static-1.1142",
  "bend-plugin-foundations-theming": "static-1.2676",
  "foundations-theming-base": "static-1.3178",
  "stylex": "static-1.27",
  "js-cookie": "static-1.18",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4258",
  "react-flip-move": "static-1.65",
  "bender-build-tools": "static-1.2926",
  "inbound-db-properties-service-client": "static-1.3659",
  "superstore": "static-1.4554",
  "feedback-loader": "static-1.28822",
  "ai-components-ui-library": "static-1.8304",
  "ui-addon-video-player": "static-1.8478",
  "ui-coaching-tips": "static-1.27901",
  "sassPrefix": "static-1.151",
  "react-dnd-compat": "static-1.4405",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2267",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7944",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4431",
  "content-media-composition-data-lib": "static-1.11388",
  "content-media-compositions": "static-2.15395",
  "idb-keyval": "static-1.39",
  "immer": "static-1.33",
  "immerable": "static-1.3937",
  "magpie-lib": "static-1.5377",
  "magpie-types": "static-1.4837",
  "media-bridge-lib": "static-1.18536",
  "video-data-lib": "static-1.34171",
  "commerce-products-lib": "static-1.8815",
  "crm-message-bus": "static-1.42310",
  "growth-data-modal": "static-1.5133",
  "hubspot-apollo-client": "static-1.4663",
  "onboarding-tours-client": "static-1.4445",
  "calling-global-api": "static-1.63598",
  "calling-internal-common": "static-1.31074",
  "calling-lifecycle-internal": "static-1.64980",
  "calling-lifecycle-messages": "static-1.57274",
  "conditional-properties-service-client": "static-1.3607",
  "crm-links": "static-1.6040",
  "customer-data-objects-ui-components": "static-1.12788",
  "customer-data-property-utils": "static-1.7855",
  "external-options-client-types": "static-1.3968",
  "file-manager-components": "static-1.22837",
  "framework-data-schema-resolvers": "static-1.6653",
  "google-libphonenumber": "static-1.33",
  "hs-entities": "static-1.458",
  "inbound-db-meta-service-client": "static-1.3401",
  "inbounddb-objects-service-types": "static-1.4033",
  "meetings-icalendar-utils-lib": "static-1.416",
  "multi-currency-client-types": "static-1.3501",
  "object-builder-ui-client": "static-1.47915",
  "pipeline-validation-client-types": "static-1.3770",
  "property-value-citations": "static-1.1369",
  "pulse": "static-1.290",
  "smart-property-lib": "static-1.5838",
  "tiered-pricing": "static-1.803",
  "ui-addon-form-validation": "static-1.10777",
  "growth-onboarding-confetti": "static-1.2853",
  "growth-onboarding-next-action-utils": "static-1.1279",
  "navigation-components": "static-1.17216",
  "onboarding-tours-utils": "static-1.297",
  "ui-shepherd-tracker": "static-1.7309",
  "ui-universal-auth": "static-1.8667",
  "batch-promise": "static-1.1332",
  "navigation-messaging": "static-1.6543",
  "getting-started-shared-tasks-store": "static-1.16956",
  "hubspotter-http-shared-msw-handlers": "static-1.9437",
  "audio-components": "static-1.5588",
  "FileManagerCore": "static-1.38336",
  "FileManagerImages": "static-1.35988",
  "video-components": "static-1.12516",
  "foundations-components-legacy": "static-1.516",
  "growth-monetization-service-types": "static-1.4301",
  "nav-client-types": "static-1.2139",
  "purchase-motions-api": "static-1.5462",
  "signup-constants": "static-1.18350",
  "signup-ui-url-generator": "static-2.7851",
  "trials-service-types": "static-1.3702",
  "chatspot-core": "static-1.20240",
  "chirp-fetch": "static-1.1666",
  "ContentUtils": "static-1.67575",
  "copilot-toolkit": "static-1.10481",
  "growth-onboarding-feedback-components": "static-1.6368",
  "hls.js": "static-1.34",
  "reactive-lib": "static-1.508",
  "simple-logging-lib": "static-1.2833",
  "customer-data-tracking": "static-1.6664",
  "products-iframe-lib": "static-1.7270",
  "products-ui-components-shared-msw-handlers": "static-1.9821",
  "hubspot-apollo-cache": "static-1.122",
  "calling-error-reporting": "static-1.31080",
  "shared-worker-versioning": "static-1.10820",
  "calling-usage-tracker": "static-1.6322",
  "voice-sms-access-library": "static-1.200",
  "conversations-skeleton-state": "static-1.7031",
  "location-customization-utils-lib": "static-1.8513",
  "crm-pipelines-api-client-types": "static-1.3948",
  "framework-builder-read-service-client": "static-1.3817",
  "framework-data-schema-quick-fetch": "static-1.6558",
  "persist-promise": "static-1.3489",
  "directed-graph": "static-1.720",
  "event-emitter": "static-1.730",
  "breeze-intelligence-kit": "static-1.5297",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9522",
  "fsm": "static-1.3514",
  "policy-lib": "static-1.6565",
  "react-tinymce": "static-1.54574",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9585",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53700",
  "tinymce-plugins": "static-1.56814",
  "tinymce-themes": "static-1.55670",
  "unified-auth-core-lib": "static-1.462",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4316",
  "video-embed": "static-1.35005",
  "content-icons-ui": "static-1.2148",
  "social-insights-client-types": "static-1.21278",
  "eligibility-engine-service-types": "static-1.2983",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4588",
  "integrations-lib": "static-1.15364",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4075",
  "calling-orchestration-schema": "static-1.34977",
  "crm-record-cards-service-types": "static-1.3436",
  "highcharts": "static-8.99",
  "trellis-story-utils": "static-1.4306",
  "storybook-react": "static-1.28",
  "hub-http-contrib": "static-1.2828",
  "interframe": "static-3.4574",
  "tinymce-data": "static-1.39785",
  "ui-addon-sales-email": "static-1.4995",
  "codemirror": "static-5.90",
  "layout-dnd-components": "static-1.12002",
  "layout-dnd-utils": "static-1.10977",
  "react-codemirror": "static-1.10409",
  "ui-brand-identity-lib": "static-1.13786",
  "NamespacedHubStyle": "static-2.8880",
  "outpost": "static-1.3988",
  "flux-actions": "static-1.306",
  "integrations-error-boundary-lib": "static-1.12779",
  "integrations-tracking-lib": "static-1.5368",
  "native-integrations-shared-strings": "static-1.7571",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10156",
  "rxjs": "static-5.10",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67650",
  "layout-data-lib": "static-1.9302",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.2781",
  "advanced-menus-core": "static-1.14787",
  "advanced-menus-lib": "static-1.11766",
  "ExportDialog": "static-6.10169",
  "ui-memberships-settings-lib": "static-1.33384",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14786",
  "simple-menus-lib": "static-1.16303"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.1645",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.444",
  "data-fetching-client": "/data-fetching-client/static-1.9462",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.387",
  "growth-payments-core": "/growth-payments-core/static-1.24685",
  "head-dlb": "/head-dlb/static-1.4754",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5375",
  "hs-test-utils": "/hs-test-utils/static-1.7788",
  "hub-http": "/hub-http/static-1.5966",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9439",
  "hubspot-dlb": "/hubspot-dlb/static-2.1796",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17564",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3917",
  "HubStyleTokens": "/HubStyleTokens/static-2.11206",
  "I18n": "/I18n/static-7.1564",
  "immutable": "/immutable/static-2.19",
  "jasmine-runner": "/jasmine-runner/static-1.6255",
  "payment-link-components": "/payment-link-components/static-1.22898",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.6703",
  "quartz-core": "/quartz-core/static-1.5922",
  "react": "/react/static-7.177",
  "react-colorpicker": "/react-colorpicker/static-2.9993",
  "react-dlb": "/react-dlb/static-1.71",
  "react-utils": "/react-utils/static-2.5157",
  "rich-text-lib": "/rich-text-lib/static-1.19442",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17626",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5344",
  "UIComponents": "/UIComponents/static-3.8153",
  "foundations-assets": "/foundations-assets/static-1.4618",
  "foundations-components": "/foundations-components/static-1.7491",
  "foundations-theming": "/foundations-theming/static-1.4193",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1909",
  "framer-motion": "/framer-motion/static-1.67",
  "history": "/history/static-4.47",
  "metrics-js": "/metrics-js/static-1.9391",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "portals-platform-lib": "/portals-platform-lib/static-1.516",
  "quartz-config": "/quartz-config/static-1.481",
  "quartz-routing": "/quartz-routing/static-1.133",
  "quick-fetch": "/quick-fetch/static-1.3718",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16426",
  "react-router-dom": "/react-router-dom/static-5.26",
  "sanitize-text": "/sanitize-text/static-1.7922",
  "styled-components": "/styled-components/static-2.84",
  "tanstack-table": "/tanstack-table/static-1.50",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4549",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9331",
  "usage-tracker": "/usage-tracker/static-1.7115",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5532",
  "usage-tracker-core": "/usage-tracker-core/static-1.6965",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "raven": "/raven/static-3.5624",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.66",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3211",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2980",
  "quartz-webpack": "/quartz-webpack/static-1.2927",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.77",
  "customer-data-objects": "/customer-data-objects/static-1.7429",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7707",
  "laboratory-lib": "/laboratory-lib/static-3.6945",
  "onboarding-scopes": "/onboarding-scopes/static-1.6246",
  "rpc-client-utils": "/rpc-client-utils/static-1.4415",
  "ui-addon-opt": "/ui-addon-opt/static-4.8168",
  "HeadJS": "/HeadJS/static-2.706",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2899",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.147",
  "ts-schema": "/ts-schema/static-1.3887",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7424",
  "cssUtils": "/cssUtils/static-1.726",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9608",
  "HubStyle": "/HubStyle/static-2.11514",
  "knowledge-content-types": "/knowledge-content-types/static-1.8352",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "quartz-i18n": "/quartz-i18n/static-1.378",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.483",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9672",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10918",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8809",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9928",
  "video-components-external": "/video-components-external/static-1.10513",
  "i18n-data": "/i18n-data/static-1.216",
  "moment-timezone": "/moment-timezone/static-5.78",
  "jasmine": "/jasmine/static-4.4111",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5691",
  "customer-data-properties": "/customer-data-properties/static-1.50755",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17838",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4870",
  "onboarding-tours": "/onboarding-tours/static-1.16231",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7874",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3461",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8825",
  "user-context": "/user-context/static-1.4878",
  "dispatcher": "/dispatcher/static-1.132",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.789",
  "hubspotter-http": "/hubspotter-http/static-1.4461",
  "icons": "/icons/static-2.620",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.479",
  "module-federation": "/module-federation/static-1.18",
  "quartz-auth": "/quartz-auth/static-1.378",
  "quartz-head": "/quartz-head/static-1.368",
  "quartz-test": "/quartz-test/static-1.378",
  "ui-fonts": "/ui-fonts/static-1.468",
  "usage-tracker-container": "/usage-tracker-container/static-1.7105",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9211",
  "data-token-picker": "/data-token-picker/static-1.16014",
  "FileManagerLib": "/FileManagerLib/static-1.38477",
  "property-translator": "/property-translator/static-1.5196",
  "atom": "/atom/static-1.4853",
  "merchandise-lib": "/merchandise-lib/static-1.258",
  "purchase-motions-components": "/purchase-motions-components/static-1.5459",
  "salesImages": "/salesImages/static-1.520",
  "self-service-api": "/self-service-api/static-1.10019",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4974",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.94",
  "ui-images": "/ui-images/static-2.1087",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3760",
  "floating-ui": "/floating-ui/static-1.51",
  "react-aria": "/react-aria/static-1.61",
  "trellis-assets": "/trellis-assets/static-1.1142",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2676",
  "foundations-theming-base": "/foundations-theming-base/static-1.3178",
  "stylex": "/stylex/static-1.27",
  "js-cookie": "/js-cookie/static-1.18",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4258",
  "react-flip-move": "/react-flip-move/static-1.65",
  "bender-build-tools": "/bender-build-tools/static-1.2926",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3659",
  "superstore": "/superstore/static-1.4554",
  "feedback-loader": "/feedback-loader/static-1.28822",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8304",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8478",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27901",
  "sassPrefix": "/sassPrefix/static-1.151",
  "react-dnd-compat": "/react-dnd-compat/static-1.4405",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2267",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7944",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4431",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11388",
  "content-media-compositions": "/content-media-compositions/static-2.15395",
  "idb-keyval": "/idb-keyval/static-1.39",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3937",
  "magpie-lib": "/magpie-lib/static-1.5377",
  "magpie-types": "/magpie-types/static-1.4837",
  "media-bridge-lib": "/media-bridge-lib/static-1.18536",
  "video-data-lib": "/video-data-lib/static-1.34171",
  "commerce-products-lib": "/commerce-products-lib/static-1.8815",
  "crm-message-bus": "/crm-message-bus/static-1.42310",
  "growth-data-modal": "/growth-data-modal/static-1.5133",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4663",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4445",
  "calling-global-api": "/calling-global-api/static-1.63598",
  "calling-internal-common": "/calling-internal-common/static-1.31074",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64980",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57274",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3607",
  "crm-links": "/crm-links/static-1.6040",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12788",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7855",
  "external-options-client-types": "/external-options-client-types/static-1.3968",
  "file-manager-components": "/file-manager-components/static-1.22837",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6653",
  "google-libphonenumber": "/google-libphonenumber/static-1.33",
  "hs-entities": "/hs-entities/static-1.458",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3401",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4033",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.416",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3501",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47915",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3770",
  "property-value-citations": "/property-value-citations/static-1.1369",
  "pulse": "/pulse/static-1.290",
  "smart-property-lib": "/smart-property-lib/static-1.5838",
  "tiered-pricing": "/tiered-pricing/static-1.803",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10777",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2853",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1279",
  "navigation-components": "/navigation-components/static-1.17216",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.297",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7309",
  "ui-universal-auth": "/ui-universal-auth/static-1.8667",
  "batch-promise": "/batch-promise/static-1.1332",
  "navigation-messaging": "/navigation-messaging/static-1.6543",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16956",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9437",
  "audio-components": "/audio-components/static-1.5588",
  "FileManagerCore": "/FileManagerCore/static-1.38336",
  "FileManagerImages": "/FileManagerImages/static-1.35988",
  "video-components": "/video-components/static-1.12516",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.516",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4301",
  "nav-client-types": "/nav-client-types/static-1.2139",
  "purchase-motions-api": "/purchase-motions-api/static-1.5462",
  "signup-constants": "/signup-constants/static-1.18350",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7851",
  "trials-service-types": "/trials-service-types/static-1.3702",
  "chatspot-core": "/chatspot-core/static-1.20240",
  "chirp-fetch": "/chirp-fetch/static-1.1666",
  "ContentUtils": "/ContentUtils/static-1.67575",
  "copilot-toolkit": "/copilot-toolkit/static-1.10481",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6368",
  "hls.js": "/hls.js/static-1.34",
  "reactive-lib": "/reactive-lib/static-1.508",
  "simple-logging-lib": "/simple-logging-lib/static-1.2833",
  "customer-data-tracking": "/customer-data-tracking/static-1.6664",
  "products-iframe-lib": "/products-iframe-lib/static-1.7270",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9821",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.122",
  "calling-error-reporting": "/calling-error-reporting/static-1.31080",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10820",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6322",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.200",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7031",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8513",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3948",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3817",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6558",
  "persist-promise": "/persist-promise/static-1.3489",
  "directed-graph": "/directed-graph/static-1.720",
  "event-emitter": "/event-emitter/static-1.730",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5297",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9522",
  "fsm": "/fsm/static-1.3514",
  "policy-lib": "/policy-lib/static-1.6565",
  "react-tinymce": "/react-tinymce/static-1.54574",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9585",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53700",
  "tinymce-plugins": "/tinymce-plugins/static-1.56814",
  "tinymce-themes": "/tinymce-themes/static-1.55670",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.462",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4316",
  "video-embed": "/video-embed/static-1.35005",
  "content-icons-ui": "/content-icons-ui/static-1.2148",
  "social-insights-client-types": "/social-insights-client-types/static-1.21278",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2983",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4588",
  "integrations-lib": "/integrations-lib/static-1.15364",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4075",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34977",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3436",
  "highcharts": "/highcharts/static-8.99",
  "trellis-story-utils": "/trellis-story-utils/static-1.4306",
  "storybook-react": "/storybook-react/static-1.28",
  "hub-http-contrib": "/hub-http-contrib/static-1.2828",
  "interframe": "/interframe/static-3.4574",
  "tinymce-data": "/tinymce-data/static-1.39785",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4995",
  "codemirror": "/codemirror/static-5.90",
  "layout-dnd-components": "/layout-dnd-components/static-1.12002",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10977",
  "react-codemirror": "/react-codemirror/static-1.10409",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13786",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8880",
  "outpost": "/outpost/static-1.3988",
  "flux-actions": "/flux-actions/static-1.306",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12779",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5368",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7571",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10156",
  "rxjs": "/rxjs/static-5.10",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67650",
  "layout-data-lib": "/layout-data-lib/static-1.9302",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2781",
  "advanced-menus-core": "/advanced-menus-core/static-1.14787",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11766",
  "ExportDialog": "/ExportDialog/static-6.10169",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33384",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14786",
  "simple-menus-lib": "/simple-menus-lib/static-1.16303"
}
};
